import { render, staticRenderFns } from "./certificateImageSettings.vue?vue&type=template&id=6300d39c&scoped=true&"
import script from "./certificateImageSettings.vue?vue&type=script&lang=js&"
export * from "./certificateImageSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6300d39c",
  null
  
)

export default component.exports